import { StepType } from '@reactour/tour';
import { FinalStepContent } from './FinalStepContent';
import {
  PiHandWavingBold,
  PiMagnifyingGlass,
  PiMusicNoteSimple,
  PiPlayFill,
  PiPlaylistLight,
  PiPower,
} from 'react-icons/pi';
import type { TFunction } from 'i18next';

export const getSteps = (t: TFunction): StepType[] => [
  {
    selector: '[data-testid="open_samples_menu_btn"]',
    content: (
      <div>
        <h2 className='flex items-center gap-2 mb-0.5 text-lg font-semibold'>
          {t('tours.mainTour.welcome_title')}
        </h2>
        <br />
        <span className='inline-flex align-middle items-center gap-1'>
          {t('tours.mainTour.welcome_desc')}
          <PiPlaylistLight size={30} className='fill-white' />,
        </span>
        {t('tours.mainTour.open_samples_menu')}
      </div>
    ),
    position: 'right' as StepType['position'],
  },
  {
    selector: '[data-radix-popper-content-wrapper]',
    content: (
      <div>
        <h2 className='flex items-center gap-2 text-lg font-semibold'>
          {/* <PiMagnifyingGlassBold size={20} /> */}
          {t('tours.mainTour.select_sheet_title')}
        </h2>
        <br />
        {t('tours.mainTour.select_sheet_desc')}
        <br />
        <div className='mt-4 flex flex-row gap-1 items-center'>
          <PiMagnifyingGlass size={20} className='fill-white' />
          <em>
            {t('tours.mainTour.search_tip')}{' '}
            {t('tours.mainTour.search_tip_example')}
          </em>
        </div>
      </div>
    ),
    position: 'left' as StepType['position'],
  },
  {
    selector: '[data-testid="start_practice_mode"]',
    content: (
      <div>
        <h2 className='flex items-center gap-2 text-lg font-semibold'>
          {t('tours.mainTour.practice_mode_title')}
        </h2>
        <br />
        {t('tours.mainTour.practice_mode_desc')}
         {t('tours.mainTour.practice_mode_highlight')}
        <span className='inline-flex align-middle items-center ml-1'>
          <PiMusicNoteSimple size={20} className='fill-[#B6FF3B]' />
        </span>
        , {t('tours.mainTour.practice_mode_next')}
        <br />
      </div>
    ),
    position: 'top' as StepType['position'],
  },
  {
    selector: '[data-testid="rednotes_show_btn"]',
    content: (
      <div>
        <h2 className='flex items-center gap-2 text-lg font-semibold'>
          {t('tours.mainTour.show_errors_title')}
        </h2>
        <br />
        {t('tours.mainTour.show_errors_desc')}
        <span className='inline-flex align-middle items-center ml-1'>
          <PiMusicNoteSimple size={20} className='fill-[#FF3B30]' />
        </span>
        <br />
      </div>
    ),
    position: 'top' as StepType['position'],
  },
  {
    selector: '[data-testid="start_play_mode"]',
    content: (
      <div>
        <h2 className='flex items-center text-lg font-semibold'>
          {t('tours.mainTour.play_mode_title')}
        </h2>
        <br />
        <div>
          {t('tours.mainTour.play_mode_desc')}
           <PiPlayFill size={20} className='fill-white inline-block mx-1' />
          {t('tours.mainTour.play_mode_extra')}
        </div>
      </div>
    ),
    position: 'top' as StepType['position'],
  },
  {
    selector: '[data-testid="start_play_btn"]',
    content: (
      <div>
        <h2 className='flex items-center gap-2 text-lg font-semibold'>
          {t('tours.mainTour.play_button_title')}
        </h2>
        <br />
        {t('tours.mainTour.play_button_desc')}
        <PiPlayFill size={20} className='fill-white inline-block mx-1' />
        {t('tours.mainTour.play_button_extra')}
      </div>
    ),
    position: 'top' as StepType['position'],
  },
  {
    selector: '#metronome',
    content: (
      <div>
        <h2 className='flex items-center gap-2 text-lg font-semibold'>
          {t('tours.mainTour.metronome_title')}
        </h2>
        <br />
        <span className='inline-flex align-middle items-center gap-1'>
          {t('tours.mainTour.metronome_desc')}
          <PiPower size={20} className='fill-white' />
        </span>{' '}
        <br />
        {t('tours.mainTour.metronome_extra')}
      </div>
    ),
    position: 'top' as StepType['position'],
  },
  {
    selector: '#hand_change',
    content: (
      <div>
        <h2 className='flex items-center gap-2 text-lg font-semibold'>
          {t('tours.mainTour.hand_select_title')}{' '}
          <PiHandWavingBold size={20} className='fill-white' />
        </h2>
        <br />
        {t('tours.mainTour.hand_select_desc')}
      </div>
    ),
    position: 'top' as StepType['position'],
  },
  {
    selector: '[data-testid="trigger_blind_btn"]',
    content: <FinalStepContent />, 
    position: 'top' as StepType['position'],
  },
];
